import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import {
  snakeCasetoTitleCase,
  camelCaseToTitleCase,
} from "../../helpers/utils";

function CustomDatePicker({ cell, col, row, handleValueChange, errors = {} }) {
  const [selectedDate, setSelectedDate] = useState(cell.getValue() || "");

  // Set minimum date to be tomorrow (i.e., the day after today)
  const minDate = moment().add(1, "days").startOf("day");

  const handleDateChange = (newValue) => {
    if (newValue) {
      setSelectedDate(newValue);
      const localDate = moment(newValue)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      handleValueChange(localDate);
    }
  };

  const errorText = errors?.[col] || ""; // Use optional chaining and fallback value
  console.log("Text error ", errorText);

  if (col === "valid_from" || col === "valid_to") {
    return (
      <DatePicker
        label={snakeCasetoTitleCase(col)}
        value={selectedDate}
        onChange={(newValue) => handleDateChange(newValue)}
        slotProps={{
          textField: {
            fullWidth: true,
            margin: "normal",
            error: Boolean(errorText),
            helperText: errorText,
          },
        }}
        disabled={col !== "valid_to"}
        minDate={
          col === "valid_to"
            ? moment(row.original.valid_from).add(1, "days")
            : undefined
        }
      />
    );
  }
  if (col === "validFrom" || col === "validTo") {
    return (
      <DatePicker
        label={camelCaseToTitleCase(col)}
        value={selectedDate}
        onChange={(newValue) => handleDateChange(newValue)}
        slotProps={{
          textField: {
            fullWidth: true,
            margin: "normal",
            error: Boolean(errorText),
            helperText: errorText,
          },
        }}
        disabled={col !== "validTo"}
        minDate={
          col === "validTo"
            ? moment(row.original.validFrom).add(1, "days")
            : undefined
        }
      />
    );
  }
}

export default CustomDatePicker;
